import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import RoleGuard from './components/admin/RoleGuard';
import Layout from './components/layout/Layout';
import DashboardPage from './pages/dashboard/DashboardPage';
import FlashCheckPage from './pages/flashcheck/FlashCheckPage';
import AdminPanelPage from './pages/admin/AdminPanelPage';
import SuperAdminPortal from './components/admin/superadmin/SuperAdminPortal';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/flashcheck" element={<FlashCheckPage />} />
                <Route 
                  path="/admin" 
                  element={
                    <RoleGuard requiredRole="admin">
                      <AdminPanelPage />
                    </RoleGuard>
                  } 
                />
                <Route 
                  path="/superadmin" 
                  element={
                    <RoleGuard requiredRole="super_admin" requireIntuitionAIDomain={true}>
                      <SuperAdminPortal />
                    </RoleGuard>
                  } 
                />
              </Routes>
            </Layout>
          </ProtectedRoute>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
